import styled from '@emotion/styled';
import { SPACER } from 'radiance-ui/lib/constants';

import { mobileOnly } from 'styles/mixins/displayMobileDesktop';
import COLORS from 'styles/constants/colors';

export const HeroImageContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${SPACER.large};
  ${mobileOnly()}
`;

export const Chip = styled.span`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  background-color: ${COLORS.surfaceOrange};
  color: ${COLORS.textDefault};
  padding: ${SPACER.xsmall} ${SPACER.small};
`;
